import React, {useEffect, useState, useRef} from "react";
import {createSearchParams, generatePath, useNavigate, useParams, useSearchParams} from "react-router-dom";
import {Card, Col, Row, Spin, Image, Grid, Collapse, Modal} from "antd";
import {useDispatch, useSelector} from "react-redux";
import {fetchCardsListAction, fetchCardsThemeListAction, fetchContentByCategoryAction, fetchMarathonDaysAction, fetchMarathonTaskAction, fetchMarathonTasksAction, fetchMarathonWeeksAction, fetchDiaryTableAction, ROUTE_PATH, selectStore, taskCompleteAction, setTaskCompletedLocal} from "../../utils";
import {MySegmented,MyText} from "../../components";
import {LeftOutlined} from "@ant-design/icons";
import MainImage from '../../assets/images/pages/SpeechMarathon/section-1-img.svg'
import { COOKIE_KEY } from "../../utils";

import { PageName, ButtonContainer, ScrollableCol } from "./style";
import { useTranslation } from "react-i18next";
import { useEmbeddedNavigate } from "../../utils/context/embed";
import { Helmet } from "react-helmet";
import { LessonCard } from "../../components/pages/MarathonSpeech/LessonPageComponent";
import { HintBlock } from "../../components/pages/MarathonSpeech/HintBlock";
import { TableBlock } from "../../components/pages/MarathonSpeech/TableBlock";
import { DiaryModal } from "../../components/pages/MarathonSpeech/DiaryModal";
import { ChildSelectModal } from "../../components/pages/MarathonSpeech/ChildSelectModal";
import {Cookies} from "react-cookie";

export const MarathonSpeechPage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const embeddedNavigate = useEmbeddedNavigate();
  const [searchTerm, setSearchTerm] = useState('');
  const [searchParams, setSearchParams] = useSearchParams();
  const {t} = useTranslation("common")
  const {useBreakpoint} = Grid;
  const screens = useBreakpoint();
  const age = searchParams.get("age");
  let fromAge = "";
  let toAge = "";

  if (age) {
    [fromAge, toAge] = age.split('-');
  }
  const isMobile = screens.xs;
  const { Panel } = Collapse;
  const topicIdFromParams = searchParams.get('topic_id');
  const segmentedParams: any = searchParams.get('type');
  const initialTopicId = topicIdFromParams ? Number(topicIdFromParams) : null;
  const [selectedSubThemeId, setSelectedSubThemeId] = useState<number | null>(initialTopicId);
 
  const [selectedParentTheme, setSelectedParentTheme] = useState<any>(null);
  const [selectedSubThemeName, setSelectedSubThemeName] = useState(null);
  const [themes, setThemes] = useState([]);


    const contentByLesson = useSelector((state: any) => state.materials?.contentByLesson ?? { data: null, loading: false });
    
    const [isOpen, setIsOpen] = useState(false);
    const [content, setContent] = useState<any>(null);
    const contentByCategory = useSelector((state: any) => state.materials?.contentByCategory ?? { data: null, loading: false });
    
    const weeksList = useSelector((state: any) => state.materials?.weeksList ?? { data: null, loading: false });
    const daysList = useSelector((state: any) => state.materials?.daysList ?? { data: null, loading: false });
    const tasksList = useSelector((state: any) => state.materials?.tasksList ?? { data: null, loading: false });
    const taskDetail = useSelector((state: any) => state.materials?.taskDetail ?? { data: null, loading: false });
    const tasksByDay = useSelector((state: any) => state.materials?.tasksByDay ?? {});


    const [selectedWeekId, setSelectedWeekId] = useState<number | null>(null);
    // const [days, setDays] = useState<any[]>([]);
    // const [localTasksByDay, setlocalTasksByDay] = useState<Record<number, any[]>>({});
    const [lessonContent, setLessonContent] = useState<Record<number, any>>({});

    const [activeKey, setActiveKey] = useState<Record<string, string | string[]>>({});
    const [completedSteps, setCompletedSteps] = useState<Record<string, number[]>>({});
    const [buttonAnimation, setButtonAnimation] = useState<Record<string, Record<number, boolean>>>({});
    const [hideButton, setHideButton] = useState<Record<string, Record<number, boolean>>>({});
    const [loadingPDF, setLoadingPDF] = useState<Record<number, boolean>>({});
    const [openKeys, setOpenKeys] = useState<string[]>([]);
    const [isPlaying, setIsPlaying] = useState<boolean[]>([]);
    const [modalVisible, setModalVisible] = useState(false);
    const [selectedVideo, setSelectedVideo] = useState<string | null>(null);
    const [daysByWeek, setDaysByWeek] = useState<Record<number, any[]>>({});
    const urlParams = new URLSearchParams(window.location.search);

    const isEmbed = urlParams.get('embed'); 
    const eToken = urlParams.get('etoken'); 
    const cookies = new Cookies()

    const [isModalVisible, setIsModalVisible] = useState(false);
    const [selectedDayId, setSelectedDayId] = useState<number | null>(null);
    // const [childSelectVisible, setChildSelectVisible] = useState(true);
    // const [selectedChildId, setSelectedChildId] = useState<number | null>(null);
    const selectedChildId = useSelector((state: any) => state.materials?.selectedChildId?.data ?? null);


    const [openedLessonsByDay, setOpenedLessonsByDay] = useState<Record<string, Set<number>>>({});

    const [activeKeyTheme, setActiveKeyTheme] = useState(null);
    const scrollableRef = useRef<HTMLDivElement | null>(null);
    const [localTasksByDay, setLocalTasksByDay] = useState<Record<number, any[]>>({});
    const taskComplete = useSelector((state: any) => state.materials?.taskComplete ?? { success: false, data: null });

    const SPECIALIST_TYPE = [
    {
      key: 'developing',
      title: `${t("developing")}`
    },
    {
      key: 'letsPlay',
      title: `${t("letsPlay")}`
    },
    {
      key: 'checkYourself',
      title: `${t("checkYourself")}`
    },
    {
      key: 'parentsRecommendations',
      title: `${t("parentsRecommendations")}`
    },
  ];

   const showModal = (dayId: number) => {
    setSelectedDayId(dayId);
    setIsModalVisible(true);
    };

  const handleOk = () => {
    setIsModalVisible(false);
    if (selectedWeekId && selectedChildId) {
        dispatch(fetchDiaryTableAction({ weekId: selectedWeekId, childId: selectedChildId }));
    }
    };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  useEffect(() => {
    setLocalTasksByDay(tasksByDay);
}, [tasksByDay]);

    useEffect(() => {
    if (!taskComplete.success || !taskComplete.data?.task_id) return;
    const { task_id, completed } = taskComplete.data;

    for (const dayId in localTasksByDay) {
        const found = localTasksByDay[dayId]?.some((t: any) => t.id === task_id);
        if (found) {
            dispatch(setTaskCompletedLocal({ dayId: Number(dayId), taskId: task_id, completed }));
            break;
        }
    }
}, [taskComplete.success, taskComplete.data]);

  useEffect(() => {
  const topicIdFromParams = searchParams.get('topic_id');

  if (!topicIdFromParams) {
    setSelectedSubThemeId(null);
    setSelectedSubThemeName(t("all"));
    setSelectedParentTheme({ id: null, name: t("all") });
    return;
  }

  const topicId = Number(topicIdFromParams);
  const matchedTheme = themes.find(theme => theme.id === topicId);

  if (matchedTheme) {
    setSelectedSubThemeId(topicId);
    setSelectedSubThemeName(matchedTheme.name);
    setSelectedParentTheme(matchedTheme);
  } else {
    setSelectedSubThemeId(null);
    setSelectedSubThemeName(t("all"));
    setSelectedParentTheme({ id: null, name: t("all") });
  }
}, [themes, searchParams, t]);

useEffect(() => {
    if (!segmentedParams) {
      handleChangeSegmented(SPECIALIST_TYPE[1].key);
    }
  }, [searchParams]);


    useEffect(() => {
        dispatch(fetchMarathonWeeksAction());
    }, []);

    useEffect(() => {
    if (!Array.isArray(weeksList.data) || !weeksList.data.length) return;
    const firstWeek = weeksList.data[0];
    setSelectedWeekId(firstWeek.id);
}, [weeksList.data]);

    useEffect(() => {
        if (!selectedWeekId) return;
        dispatch(fetchMarathonDaysAction(selectedWeekId));
    }, [selectedWeekId]);


    useEffect(() => {
        if (!daysList.success || !daysList.data?.days) return;
        const weekId = daysList.data?.week?.id;
        if (!weekId) return;
        setDaysByWeek(prev => ({ ...prev, [weekId]: daysList.data.days }));

        daysList.data.days.forEach((day: any) => {
            dispatch(fetchMarathonTasksAction({ dayId: day.id, childId: selectedChildId }));
        });
    }, [daysList.success, daysList.data, selectedChildId]);

    useEffect(() => {
        if (!taskDetail.success || !taskDetail.data) return;
        const task = taskDetail.data?.task;
        if (!task.id) return;
        setLessonContent(prev => ({ ...prev, [task.id]: task }));
    }, [taskDetail.success, taskDetail.data]);

   const completeStep = (stepIndex: number, dayKey: string) => {
    setCompletedSteps(prev => ({
        ...prev,
        [dayKey]: [...(prev[dayKey] ?? []), stepIndex],
    }));
    setHideButton(prev => ({
        ...prev,
        [dayKey]: { ...(prev[dayKey] ?? {}), [stepIndex]: true },
    }));
    setButtonAnimation(prev => ({
        ...prev,
        [dayKey]: { ...(prev[dayKey] ?? {}), [stepIndex]: true },
    }));
    setIsPlaying(prev => {
        const updated = [...prev];
        updated[stepIndex - 1] = false;
        return updated;
    });
};

    const handleCollapseChange = (key: string | string[], lessonId: number, dayKey: string) => {
        const isNowOpen = Array.isArray(key)
            ? key.includes(String(lessonId))
            : key === String(lessonId);

        if (isNowOpen && !lessonContent[lessonId]) {
            dispatch(fetchMarathonTaskAction(lessonId));
        }

        if (isNowOpen) {
            setOpenedLessonsByDay(prev => {
                const current = prev[dayKey] ? new Set(prev[dayKey]) : new Set<number>();
                current.add(lessonId);
                return { ...prev, [dayKey]: current };
            });

            const dayTasks = Array.isArray(localTasksByDay[Number(dayKey)]) ? localTasksByDay[Number(dayKey)] : [];
            const stepIndex = dayTasks.findIndex((t) => t.id === lessonId) + 1;
            if (stepIndex > 0) {
                completeStep(stepIndex, dayKey);
            }

            dispatch(setTaskCompletedLocal({
                dayId: Number(dayKey),
                taskId: lessonId,
                completed: true,
            }));

            if (selectedChildId) {
                dispatch(taskCompleteAction({
                    child_id: selectedChildId,
                    task_id: lessonId,
                    completed: true,
                }));
            }
        }

        setActiveKey(prev => ({ ...prev, [dayKey]: key }));

        if (Array.isArray(key)) setOpenKeys(key);
        else if (key) setOpenKeys([key]);
        else setOpenKeys([]);
    };

    const isDayAllOpened = (dayId: number) => {
        const dayTasks = Array.isArray(localTasksByDay[dayId]) ? localTasksByDay[dayId] : [];
        if (dayTasks.length === 0) return false;
        const opened = openedLessonsByDay[String(dayId)] ?? new Set<number>();
        return dayTasks.every((t: any) => opened.has(t.id) || t.is_completed);
    };

    const isWeekCompleted = (weekId: number) => {
    const weekDays = daysByWeek[weekId] ?? [];
        if (weekDays.length === 0) return false;
        return weekDays.every((day: any) => {
            const dayTasks = Array.isArray(localTasksByDay[day.id]) ? localTasksByDay[day.id] : [];
            return dayTasks.length > 0 && dayTasks.every((t: any) => t.is_completed);
        });
    };

    const isWeekLocked = (weekIndex: number) => {
        if (weekIndex <= 0) return false;
        const prevWeek = weeks[weekIndex - 1];
        if (!prevWeek) return false;
        return !isWeekCompleted(prevWeek.id);
    };

    const handleChangeSegmented = (value: any) => {
    const existingParams = Object.fromEntries(searchParams.entries());

    const newParams: Record<any, any> = {
        ...existingParams,
        type: value,
    };

    if (selectedSubThemeId !== null) {
        newParams.topic_id = selectedSubThemeId;
    } else {
        delete newParams.topic_id;
    }

    setSearchParams(newParams);
    setSearchTerm('');
    };

  const handleSelectCard = (supportId: any) => {
    const path = {
      pathname: generatePath(ROUTE_PATH.CURRENT_PSYCHO, {  type: segmentedParams, supportId }),
    };
    embeddedNavigate(path);
  };

  const handleGoBack = () => {
    embeddedNavigate('/diagnostics-marathon');
  }

    useEffect(() => {
        if (isEmbed && eToken) return;
    
        const token = cookies.get(COOKIE_KEY.ACCESS_TOKEN);
        if (!token) {
            embeddedNavigate("/auth");
        }
    }, [embeddedNavigate, isEmbed, eToken]);

  const toggleIcon = (index: number) => {
        setIsPlaying((prev) => {
            const updatedPlaying = [...prev];
            updatedPlaying[index] = !updatedPlaying[index];
            return updatedPlaying;
        });
    };
    
//  const handleCollapseChange = (key: string | string[], lessonId: number, dayKey: string) => {
//     setActiveKey(prev => ({ ...prev, [dayKey]: key }));
//     toggleIcon(key);

//     if (Array.isArray(key)) {
//         setOpenKeys(key);
//     } else if (key) {
//         setOpenKeys([key]);
//     } else {
//         setOpenKeys([]);
//     }
// };
  

// const completeStep = (stepIndex: number, dayKey: string) => {
//     setCompletedSteps(prev => ({
//         ...prev,
//         [dayKey]: [...(prev[dayKey] ?? []), stepIndex],
//     }));

//     setHideButton(prev => ({
//         ...prev,
//         [dayKey]: { ...(prev[dayKey] ?? {}), [stepIndex]: true },
//     }));

//     setButtonAnimation(prev => ({
//         ...prev,
//         [dayKey]: { ...(prev[dayKey] ?? {}), [stepIndex]: true },
//     }));

//     const currentKey = String(stepIndex - 1);
//     setActiveKey(prev => {
//         const prevDay = prev[dayKey];
//         if (Array.isArray(prevDay)) {
//             return { ...prev, [dayKey]: prevDay.filter(k => k !== currentKey) };
//         }
//         return { ...prev, [dayKey]: prevDay === currentKey ? '' : prevDay ?? '' };
//     });

//     setOpenKeys(prev => prev.filter(k => k !== currentKey));

//     setIsPlaying(prev => {
//         const updated = [...prev];
//         updated[stepIndex - 1] = false;
//         return updated;
//     });
// };

const handleOpenPDF = (index: number, item: any) => {
//   dispatch(fetchExportPDFAction({ id: item.id, name: item.name }));
};
  
      // const parentThemes = themes.filter(theme => theme.type === 0 && theme.parent_id == parentTheme);
      const parentThemes = themes.filter(theme => theme.type === 0 && theme.parent_id == parentTheme);
      const parentThemesButton = themes.filter(theme => theme.type === 1 && theme.parent_id == parentTheme);
  
      const handlePanelChange = async (key: string) => {
          setActiveKeyTheme(activeKeyTheme === key ? null : key);
      };

  
     const adaptIframe = (html: string) => {
    if (!html) return '';
  
    return html
    .replace(
      /(<iframe[^>]*src="https:\/\/www\.youtube\.com\/embed\/([^"?&]+)"[^>]*><\/iframe>)/gi,
      (_match, fullIframe, videoId) => {
        const wrapperTag = 'span';
        const wrapperStyle = screens.xs
          ? 'position:relative;width:100%;aspect-ratio:16/9;cursor:pointer;display:inline-block;'
          : 'position:relative;cursor:pointer;display:inline-block;';
  
        const iframeWithStyle = screens.xs
          ? fullIframe.replace(
              '<iframe',
              '<iframe style="position:absolute;top:0;left:0;width:100%;height:100%;"'
            )
          : fullIframe;
  
        return `<${wrapperTag} class="video-click-wrapper" data-video-id="${videoId}" style="${wrapperStyle}">
          <span style="position:absolute;top:0;left:0;width:100%;height:100%;z-index:2;"></span>
          ${iframeWithStyle}
        </${wrapperTag}>`;
      }
    )
    .replace(
      /<p([^>]*)>/gi,
      '<p$1 style="margin-bottom:0.2em;">'
    );
     }
const days = selectedWeekId ? (daysByWeek[selectedWeekId] ?? []) : [];

const firstIncompleteIndex = days.findIndex((day: any) => {
    const dayTasks = Array.isArray(localTasksByDay[day.id]) ? localTasksByDay[day.id] : [];
    return dayTasks.length === 0 || !dayTasks.every((task: any) => task.is_completed);
});

const weeks = Array.isArray(weeksList.data) ? weeksList.data : [];
  const currentWeek = weeks.find((w: any) => w.id === selectedWeekId);

  return (
    <>
          <Helmet>
            <title>Познавательные детские карточки</title>
            <meta name="description" content="Познавательные видео для обучения детей: речь, внимание, окружающий мир. Весёлые и полезные материалы для изучения дома и в детском саду." />
          </Helmet>


    <Row justify="center">
      <Col span={20}>
        <Row align="middle" style={{marginBottom: 30}}>
           {screens.xs ? (
              <>
                <Col span={3}>
                  <ButtonContainer onClick={handleGoBack}>
                    <LeftOutlined style={{ color: 'rgba(10, 3, 60, 0.7)' }} />
                  </ButtonContainer>
                </Col>
                <Col span={21}>
                  <MyText
                    color="rgba(19, 15, 38, 1)"
                    size={24}
                    weight={800}
                    style={{ fontFamily: 'Nunito', display: 'block', marginLeft: 12 }}
                  >
                    {t("speech_launch_marathon")}
                  </MyText>
                </Col>
              </>
            ) : (
              <>
                <ButtonContainer onClick={handleGoBack}>
                  <LeftOutlined style={{ color: 'rgba(10, 3, 60, 0.7)' }} />
                </ButtonContainer>
                <MyText
                  color="rgba(19, 15, 38, 1)"
                  size={32}
                  weight={800}
                  style={{ fontFamily: 'Nunito', display: 'block', marginLeft: 12 }}
                >
                  {t("speech_launch_marathon")}
                </MyText>
              </>
            )}
        </Row>

        <Row gutter={24}  style={{marginBottom: 30}}>
        <Col span={14}>
        <Row style={{marginBottom: 30}}>
                    <ScrollableCol ref={scrollableRef} span={24}>
                                    {weeksList.loading ? (
                                        <Spin />
                                    ) : (
                                        <MySegmented
                                            type="primary"
                                            options={weeks.map((w: any, idx: number) => ({
                                                label: w.name,
                                                value: w.id,
                                                disabled: isWeekLocked(idx),
                                            }))}
                                            onChange={(val: any) => {
                                                const idx = weeks.findIndex((w: any) => w.id === val);
                                                if (idx > 0 && isWeekLocked(idx)) return; 
                                                setSelectedWeekId(val);
                                            }}
                                        value={selectedWeekId ?? weeks?.[0]?.id}
                                    />
                                    )}
                                </ScrollableCol>
        </Row>

        {currentWeek && (
    <>
        <Col span={24} style={{ marginBottom: 30 }}>
            <Row gutter={8} align="middle">
                <Col flex="none">
                    <MyText
                        color="#C0661E"
                        size={32}
                        weight={700}
                        style={{ display: 'block' }}
                    >
                        Тема недели:
                    </MyText>
                </Col>

                <Col flex="none">
                    <MyText
                        color="#0A033C"
                        size={32}
                        weight={700}
                        style={{ display: 'block' }}
                    >
                        {currentWeek.name}
                    </MyText>
                </Col>
            </Row>
        </Col>

        {currentWeek.description && (
            <Col span={24}>
                <Row gutter={8} align="middle">
                    <Col flex="none">
                        <MyText
                            color="#364153"
                            size={24}
                            weight={400}
                            style={{
                                display: 'block',
                                lineHeight: '32px',
                            }}
                        >
                            {currentWeek.description}
                        </MyText>
                    </Col>
                </Row>
            </Col>
        )}
    </>
)}
        </Col>
        <Col span={10}>
            <Row align="middle" justify='center'>
            <Image
                                preview={false}
                                style={{height: '100%', width: '100%',
                                objectFit: 'cover'}}
                                src={MainImage}
                            />
            </Row>
        </Col>
        </Row>

    {daysList.loading ? (
                        <Row justify="center"><Spin /></Row>
                    ) : (
                        <Row gutter={[24, 0]}>
                            {days.map((day, dayIndex) => {
                                const dayTasks = Array.isArray(localTasksByDay[day.id]) ? localTasksByDay[day.id] : [];
                                const dayKey = String(day.id);
                                const dayCompleted = dayTasks.length > 0 && dayTasks.every((task: any) => task.is_completed);

                                const isLast = dayIndex === days.length - 1;
                                const isDayLocked = dayIndex > 0 && !isDayAllOpened(days[dayIndex - 1].id);
                                return (
                                    <Col span={24} key={day.id}>
                                        <Row wrap={false} align="stretch" style={{ gap: 31 }}>
                                            <Col flex="none" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                                <div style={{
                                                    width: 28, height: 28, borderRadius: 8,
                                                    background: dayCompleted ? '#13C296' : '#E5E9F2',
                                                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                                                    marginTop: 16, flexShrink: 0,
                                                }}>
                                                    {dayCompleted ? (
                                                        <svg width="14" height="11" viewBox="0 0 14 11" fill="none">
                                                            <path d="M1 5L5 9L13 1" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                                        </svg>
                                                    ) : (
                                                        <svg width="10" height="10" viewBox="0 0 10 10" fill="none">
                                                            <path d="M1 1L9 9M9 1L1 9" stroke="#9CA3AF" strokeWidth="2" strokeLinecap="round" />
                                                        </svg>
                                                    )}
                                                </div>
                                                {!isLast && (
                                                    <div style={{
                                                        width: 0, flexGrow: 1,
                                                        borderLeft: '2px dashed #D9DBE1',
                                                        marginTop: 10, marginBottom: -30,
                                                    }} />
                                                )}
                                            </Col>

                                            <Col flex="auto" style={{ paddingBottom: isLast ? 0 : 24 }}>
                                                <Card style={{ width: '100%', borderRadius: '20px',pointerEvents: isDayLocked ? 'none' : 'auto', }}>
                                                    {tasksList.loading && !localTasksByDay[day.id] ? (
                                                        <Row justify="center"><Spin /></Row>
                                                    ) : (
                                                        <LessonCard
                                                            lessons={dayTasks.map((task: any) => ({
                                                                id: task.id,
                                                                name: task.name,
                                                                content: task.description ?? '',
                                                                description: task.description,
                                                                is_completed: task.is_completed,
                                                            }))}
                                                            lessonContent={lessonContent}
                                                            activeKey={activeKey[dayKey] ?? []}
                                                            completedSteps={completedSteps[dayKey] ?? []}
                                                            buttonAnimation={buttonAnimation[dayKey] ?? {}}
                                                            hideButton={hideButton[dayKey] ?? {}}
                                                            loadingPDF={loadingPDF}
                                                            modalVisible={modalVisible}
                                                            selectedVideo={selectedVideo}
                                                            isDayLocked={isDayLocked}
                                                            title={day.name}
                                                            dayId={day.id}
                                                            showModal={showModal}
                                                            onCollapseChange={(key, lessonId) => handleCollapseChange(key, lessonId, dayKey)}
                                                            onCompleteStep={(stepIndex) => completeStep(stepIndex, dayKey)}
                                                            onOpenPDF={handleOpenPDF}
                                                            onCloseModal={() => setModalVisible(false)}
                                                            adaptIframe={adaptIframe}
                                                        />
                                                    )}
                                                </Card>
                                            </Col>
                                        </Row>
                                    </Col>
                                );
                            })}
                        </Row>
                    )}

    <Col span={24} style={{marginTop: 40}}>
        <TableBlock weekId={selectedWeekId} childId={selectedChildId}/>                            
    </Col>                                


    <Col span={24} style={{marginTop: 40}}>
        <HintBlock/>                            
    </Col>    

    {/* <ChildSelectModal
    visible={childSelectVisible}
    selectedId={selectedChildId}
    onSelect={(id) => setSelectedChildId(id)}
    onConfirm={() => setChildSelectVisible(false)}
    />                             */}
      <DiaryModal
        visible={isModalVisible}
        dayId={selectedDayId}
        childId={selectedChildId!}
        onOk={handleOk}
        onCancel={handleCancel}
        />

      </Col>
    </Row>
  </>

  )
}